import { LogOut } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { adminDisplayName, useAuth } from '@/lib/use-auth';

export const UserMenu = () => {
  const { admin, logout } = useAuth();
  if (!admin) return null;

  return (
    <div className="flex min-w-0 items-center gap-3">
      <div className="hidden min-w-0 text-right leading-tight sm:block">
        <p className="truncate text-sm font-medium">{adminDisplayName(admin)}</p>
        <p className="truncate text-xs text-muted-foreground">{admin.email}</p>
      </div>
      <Button variant="outline" size="sm" onClick={() => void logout()} aria-label="Se déconnecter">
        <LogOut className="h-4 w-4 sm:mr-2" aria-hidden />
        <span className="hidden sm:inline">Déconnexion</span>
      </Button>
    </div>
  );
};
